<template>
  <v-list-tile class="v-list-tile-fix">
    <v-list-tile-content>
      <v-list-tile-title>
        {{ byUser }}
        <span
          :title="createdDateTime"
          class="grey--text text--lighten-1">{{ createdFromNow }}</span>
      </v-list-tile-title>
      <v-list-tile-sub-title v-html="translationText"/>
    </v-list-tile-content>
  </v-list-tile>
</template>
<script>
import templateArguments from './CompanyLogTemplateArguments'

export default {
  name: 'CompanyLogEntry',
  props: ['item'],
  computed: {
    created () {
      return this.$moment(this.item.created_at, 'YYYY-MM-DD HH:mm:ss')
    },
    createdDateTime () {
      return this.created.format('DD.MM.YYYY, HH:mm')
    },
    createdFromNow () {
      return this.created.fromNow()
    },
    translationText () {
      const templateArgs = {}
      const argsGenerator = templateArguments[this.item.type]
      if (argsGenerator) {
        Object.assign(templateArgs, argsGenerator(this.item))
      }
      return this.$t(`${this.item.type}`, templateArgs)
    },
    byUser () {
      return `${this.item.user.first_name} ${this.item.user.last_name}`
    }

  },
  i18n: {
    messages: {
      en: {
        timesheet: {
          create: 'Created a timesheet <a href="{href}">Time sheet</a> (ID: {id})',
          multiple_months_batch: {
            success: 'Created a timesheet {month} for an <a href="{href}">employee</a> (ID: {id})'
          },
          multiple_users_batch: {
            success: 'Created a timesheet {month} for an <a href="{href}">employee</a> (ID: {id})'
          }
        },
        employee: {
          update: 'Updated an <a href="{href}">employee</a>  (ID: {id})',
          delete: 'Deleted an employee (ID: {id})',
          create: 'Created an <a href="{href}">employee</a>  (ID: {id})',
          assigned_as_manager: 'Assigned the role manager to an <a href="{href}">employee</a>  (ID: {id})'
        },
        employee_account: {
          create: 'Created an <a href="{href}">employee account</a>  (ID: {id}) '
        },
        timetracking: {
          start: 'Has started the time tracking',
          stop: 'Has stopped the time tracking'
        },
        activity_period: {
          create: 'Marked <a href="{href}">employee</a>  (ID: {id}) as inactive within the period {period}',
          delete: 'Removed the inactivity period {period} of the <a href="{href}">employee</a>  (ID: {id})'
        },
        salaryGroup: {
          create: 'Has created a new wage group (ID: {id})',
          update: 'Has updated a wage group (ID: {id})',
          delete: 'Has deleted a wage group (ID: {id})'
        }
      },
      tr: {
        timesheet: {
          create: 'Zaman çizelgesi yaratıldı <a href="{href}">Zaman çizelgesi</a> (ID: {id})',
          multiple_months_batch: {
            success: '<a href="{href}">Çalışan</a> için bir {month} zaman çizelgesi yaratıldı (ID: {id})'
          },
          multiple_users_batch: {
            success: '<a href="{href}">Çalışan</a> için bir {month} zaman çizelgesi yaratıldı (ID: {id})'
          }
        },
        employee: {
          update: '<a href="{href}">Çalışan</a> güncellendi  (ID: {id})',
          delete: 'Çalışan silindi (ID: {id})',
          create: '<a href="{href}">Çalışan</a> yaratıldı  (ID: {id})',
          assigned_as_manager: 'Yönetici rolü <a href="{href}">çalışana</a> atandı (ID: {id})'
        },
        employee_account: {
          create: '<a href="{href}">Çalışan hesabı</a> yaratıldı  (ID: {id}) '
        },
        timetracking: {
          start: 'Zaman takibini başlattı',
          stop: 'Zaman takibini durdurdu'
        },
        activity_period: {
          create: '<a href="{href}">Çalışan</a>  (ID: {id}) , {period} zaman aralığı için pasif olarak işaretlendi.',
          delete: '<a href="{href}">Çalışanın</a>  (ID: {id}) pasif zaman aralığı olan {period} kaldırıldı.'
        },
        salaryGroup: {
          create: 'Yeni ücret grubu (ID: {id}) tanımladı',
          update: 'Ücret grubu (ID: {id}) güncelledi',
          delete: 'Ücret grubu (ID: {id}) sildi'
        }
      },
      de: {
        timesheet: {
          create: 'Ein <a href="{href}">Stundennachweis</a> (ID: {id}) wurde erstellt',
          multiple_months_batch: {
            success: 'Der Stundennachweis {month} für einen <a href="{href}">Mitarbeiter</a> (ID: {id}) wurde erstellt'
          },
          multiple_users_batch: {
            success: 'Der Stundennachweis {month} für einen <a href="{href}">Mitarbeiter</a> (ID: {id}) wurde erstellt'
          },
          update: 'Ein <a href="{href}">Stundennachweis</a> (ID: {id}) wurde aktualisiert'
        },
        employee: {
          update: 'Ein <a href="{href}">Mitarbeiter</a>  (ID: {id}) wurde bearbeitet',
          delete: 'Ein Mitarbeiter  (ID: {id}) wurde entfernt',
          create: 'Ein <a href="{href}">Mitarbeiter</a>  (ID: {id}) wurde erstellt',
          assigned_as_manager: 'Der <a href="{href}">Mitarbeiter</a>  (ID: {id}) wurde die Rolle Manager zugewiesen. '
        },
        employee_account: {
          create: 'Ein <a href="{href}">Mitarbeiteraccount</a>  (ID: {id}) wurde erstellt'
        },
        timetracking: {
          start: 'Der <a href="{href}">Mitarbeiter</a>  (ID: {id}) hat die Zeitmessung gestartet',
          stop: 'Der <a href="{href}">Mitarbeiter</a>  (ID: {id}) hat die Zeitmessung angehalten'
        },
        activity_period: {
          create: 'Ein <a href="{href}">Mitarbeiter</a> wurde für die Periode {period} als inaktiv markiert ',
          delete: 'Die Inaktivität eines <a href="{href}">Mitarbeiters</a> in der Zeit {period} wurde entfernt'
        },
        salaryGroup: {
          create: 'Eine Lohngruppe (ID: {id}) wurde erstellt',
          update: 'Eine Lohngruppe (ID: {id}) wurde bearbeitet',
          delete: 'Eine Lohngruppe (ID: {id}) wurde entfernt'
        }
      },
      ru: {
        timesheet: {
          create: 'Создал <a href="{href}">табель</a> (ID: {id})',
          multiple_months_batch: {
            success: 'Создал табель <a href="{href}">сотрудника</a> за {month} (ID: {id})'
          },
          multiple_users_batch: {
            success: 'Создал табель <a href="{href}">сотрудника</a> за {month} (ID: {id})'
          }
        },
        employee: {
          update: 'Обновил <a href="{href}">сотрудника</a> (ID: {id})',
          delete: 'Удалил сотрудника (ID: {id})',
          create: 'Создал <a href="{href}">сотрудника</a> (ID: {id})',
          assigned_as_manager: 'Назначил роль менеджера для <a href="{href}">сотрудника</a>  (ID: {id})'
        },
        employee_account: {
          create: '<a href="{href}">Аккаунт сотрудника</a> создан (ID: {id}) '
        },
        timetracking: {
          start: 'Началось отслеживание времени',
          stop: 'Закончилось отслеживание времени'
        },
        activity_period: {
          create: 'Пометил <a href="{href}">сотрудника</a> (ID: {id}) как неактивного в период {period}',
          delete: 'Убрал период неактивности ({period}) <a href="{href}">сотрудника</a> (ID: {id})'
        },
        salaryGroup: {
          create: 'Создал новую группу заработной платы (ID: {id})',
          update: 'Обновил группу заработной платы (ID: {id})',
          delete: 'Создал новую группу заработной платы (ID: {id})'
        }
      }
    }
  }
}
</script>

<style scoped>
.v-list-tile-fix {
  margin: 0 -8px;
}
</style>
